export default class UpdateConversationItem {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId, itemAttrs }) {
    if (!customerId) {
      return;
    }

    this.context.gateways.customerHistory.updateConversationItem(customerId, conversationItemId, itemAttrs);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation_item/update_conversation_item.js